import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'

import { PublicLayoutComponent } from '../../ui'
import { Login } from '../../pages'
import { PasswordRecovery } from '../../pages'
import { Signup } from '../../pages'
import { SignupConfirmation } from '../../pages'

export const PublicRouter = () => (
  <PublicLayoutComponent>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup/confirmation/:signupToken" element={<SignupConfirmation />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/password-recovery/:id" element={<PasswordRecovery />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </PublicLayoutComponent>
)
